/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Missing_Asset_ErrorInputs */



/**
* | output |
* | --- |
* | "Unable to get Asset ID, or Token Id." |
*
* @param {Iconik_Import_Missing_Asset_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_missing_asset_error = /** @type {((inputs?: Iconik_Import_Missing_Asset_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Missing_Asset_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'obtenir l'ID d'asset ou l'ID de jeton.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Asset-ID oder Token-ID konnten nicht abgerufen werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile ottenere l'ID risorsa o l'ID token.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось получить идентификатор актива или идентификатор токена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede obtener el ID del activo o el ID del token.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法获取资产 ID 或代币 ID。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アセット ID またはトークン ID を取得できません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एसेट आईडी या टोकन आईडी प्राप्त करने में असमर्थ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível obter o ID do ativo ou o ID do token.")
	return /** @type {LocalizedString} */ ("Unable to get Asset ID, or Token Id.")
});